import BaseRestService from "./BaseRestService";

const formatNewPath = (path) => {
  const baseUrl = "https://caelor-apps.web.app/images/icons/";
  const fileName = path.substring(path.lastIndexOf("/") + 1);

  return baseUrl + fileName;
};

class StyleguidService extends BaseRestService {
  async getProperty(propertyKey) {
    const url = `/api/styleguide/${propertyKey}`;

    if (propertyKey === styleguidePropertyKeys.APP_ICONS) {
      const response = await this.client.get(
        url,
        await this.buildJWTAuthAxiosConfig()
      );

      const data = response.data.map((item) => {
        if (item.path.includes("admin.caelor.com")) {
          return { ...item, path: formatNewPath(item.path) };
        }

        return item;
      });

      return { ...response, data };
    }

    return this.client.get(url, await this.buildJWTAuthAxiosConfig());
  }

  async saveProperty(propertyKey, data) {
    const url = `/api/styleguide`;
    return this.client.post(
      url,
      { propertyKey, data },
      await this.buildJWTAuthAxiosConfig()
    );
  }

  async getPermissions(propertyKey = "permissions") {
    const url = `/api/styleguide/savedpermissions/${propertyKey}`;
    return this.client.get(url, await this.buildJWTAuthAxiosConfig());
  }

  async savePermissions(data, propertyKey = "permissions") {
    const url = `/api/styleguide/permissions`;
    return this.client.post(
      url,
      { propertyKey, data },
      await this.buildJWTAuthAxiosConfig()
    );
  }

  async checkPermissionOfUser() {
    const url = `/api/styleguide/user/permissions`;
    return this.client.get(url, await this.buildJWTAuthAxiosConfig());
  }

  async getColorPalette(paletteKey) {
    const url = `/api/styleguide/palette/${paletteKey}`;
    return this.client.get(url, await this.buildJWTAuthAxiosConfig());
  }

  async getMultiplePalette(paletteKeys) {
    const url = `/api/styleguide/multiple-palettes`;
    return this.client.post(
      url,
      { paletteKeys },
      await this.buildJWTAuthAxiosConfig()
    );
  }

  async checkOnboardingStatus() {
    const url = `/api/styleguide/onboarding-status`;
    return this.client.post(url, {}, await this.buildJWTAuthAxiosConfig());
  }

  async setOnboardingStatus(data) {
    const url = `/api/styleguide/onboarding-status/set`;
    return this.client.post(
      url,
      { data },
      await this.buildJWTAuthAxiosConfig()
    );
  }
}

export const styleguideService = new StyleguidService();

export const styleguidePropertyKeys = {
  GALLERY: "gallery",
  COLORS: "colors",
  PERMISSIONS: "permissions",
  APP_ICONS: "appicons",
};
